import { gql } from '@apollo/client';
import type { InhubSortingAccountPageInput } from '../queries/getInhubSortingAccountSummariesPage';

export const GENERATE_INHUB_SORTING_ACCOUNT_SUMMARIES_EXPORT = gql`
  mutation GenerateInhubSortingAccountSummariesExport(
    $filter: InhubSortingAccountPageInput!
    $timezone: String
  ) {
    generateInhubSortingAccountSummariesExport(filter: $filter, timezone: $timezone)
  }
`;

export interface GenerateInhubSortingAccountSummariesExportVariables {
    filter: InhubSortingAccountPageInput;
    timezone?: string;
}

export interface GenerateInhubSortingAccountSummariesExportResponse {
    generateInhubSortingAccountSummariesExport: string;
}
